import withNavigate from "../../../routes/withNavigate";
import SansthaManagerContainer from "./SansthaManagerContainer.jsx";
import SansthaManagerStore from "./SansthaManagerStore";

export default SansthaManagerStore(withNavigate(SansthaManagerContainer));